import instance, { ApiResponse } from 'api';
import { AxiosError, AxiosResponse } from 'axios';
import { BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';

const UNKNOWN_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again.';

export class DashboardApi extends BaseApi {
  public static getDashboardList = async (): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.dashboard.list
      );
      if (DashboardApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return DashboardApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          return DashboardApi.errorResponse('');
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          return DashboardApi.errorResponse('');
        }
      }
      return DashboardApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };

  public static getAutoLoginToken = async (): Promise<any> => {
    try {
      const result: AxiosResponse<ApiResponse<any>> = await instance.get(
        endpoints.dashboard.autoLoginToken
      );
      if (DashboardApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return DashboardApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          return DashboardApi.errorResponse('');
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          return DashboardApi.errorResponse('');
        }
      }
      return DashboardApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  };

  public static restartTrial = async (account_package_id: number): Promise<any> => {
    try {
      const payload = { packageID: account_package_id };

      const result: AxiosResponse<ApiResponse<any>> = await instance.post(
        endpoints.dashboard.restartTrial,
        payload
      );
      if (DashboardApi.isResponseSuccessful(result.data)) {
        const data = result.data.details;
        return DashboardApi.successResponse(data);
      } else {
        const errors = result.data.errors;
        if (errors) {
          return DashboardApi.errorResponse('');
        } else {
          throw new Error(); // Caught below to trigger unknown error
        }
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) {
          return DashboardApi.errorResponse('');
        }
      }
      return DashboardApi.errorResponse(UNKNOWN_ERROR_MESSAGE);
    }
  }; 
}
